import logo2 from 'assets/banner.jpg';
import elreenOze from 'assets/logos/elgreen-oze.png';
import elreenProj from 'assets/logos/elgreen-proj.png';
import elreenEze from 'assets/logos/elgreen-ele.png';
import menupng from 'assets/icons/menu.png';
import star from 'assets/icons/star.png';
import book from 'assets/icons/book.png';
import technology from 'assets/icons/technology.png';
import power from 'assets/icons/power.png';
import pv1 from 'assets/icons/pv1.svg';
import pv2 from 'assets/icons/pv2.svg';
import pv3 from 'assets/icons/pv3.svg';
import pv4 from 'assets/icons/pv4.svg';
import power2 from 'assets/icons/power2.png';
import fire from 'assets/icons/fire.png';
import money from 'assets/icons/money.png';
import leaf from 'assets/icons/leaf.png';
import paperMoney from 'assets/icons/paperMoney.png';
import recycling from 'assets/icons/recycling.png';
import interview from 'assets/icons/interview.png';
import settings from 'assets/icons/settings.png';
import problem from 'assets/icons/problem.png';
import phone from 'assets/icons/phone.png';
import email from 'assets/icons/email.png';
import gps from 'assets/icons/gps.png';
import location from 'assets/icons/location.png';
import contact from 'assets/images/contact.jpeg';
import elgreen1 from 'assets/images/elgreen12.jpeg';
import elgreen2 from 'assets/images/elgreen2.jpeg';
import lisc from 'assets/images/lisc.jpeg';
import tesla from 'assets/images/tesla.jpeg';
import ecocar from 'assets/images/ecocar.jpeg';
import oze from 'assets/images/oze.jpeg';
import ozeoffer from 'assets/images/windmill.jpeg';
import laka from 'assets/images/laka.jpeg';
import electrocar from 'assets/images/electrocar.jpeg';
import mainpage from 'assets/images/aboutus.jpeg';
import idea from 'assets/images/idea.jpeg';
import eko from 'assets/partners/Eko.png';
import ekoenergetyka from 'assets/partners/Ekoenergetyka.png';
import hibox from 'assets/partners/Hibox.svg';
import lignajjo from 'assets/partners/Lignajjo.png';
import prebiel from 'assets/partners/Prebiel.png';

export const cms = {
  logo: {
    oze: elreenOze,
    ele: elreenEze,
    proj: elreenProj,
  },
  logo2: {
    logo2: logo2,
  },
  icons: {
    menu: menupng,
    star,
    book,
    technology,
    power,
    pv1,
    pv2,
    pv3,
    pv4,
    power2,
    fire,
    money,
    leaf,
    paperMoney,
    recycling,
    interview,
    settings,
    problem,
    phone,
    email,
    gps,
    location,
  },
  images: {
    contact,
  },
  elgreen: {
    elgreen1: elgreen1,
    elgreen2: elgreen2,
    lisc: lisc,
    laka: laka,
    mainpage: mainpage,
    idea: idea,
  },

  electro: {
    tesla: tesla,
    ecocar: ecocar,
    electrocar: electrocar,
  },
  oze: {
    oze: oze,
    ozeoffer: ozeoffer,
  },
  partners: {
    eko: eko,
    ekoenergetyka: ekoenergetyka,
    hibox: hibox,
    lignajjo: lignajjo,
    prebiel: prebiel,
  },
};
